<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-lg-12">
          <router-link class="btn btn-dark" :to="{ name: 'inventario-conversiones' }">
            <i class="fa fa-arrow-left sliding-icon"></i>
            Regresar
          </router-link>
          <br><br>
          <div class="element-wrapper" style="padding-bottom: 60px;">
            <div>
              <div class="element-box" style="background-color: #f7d9e0;" v-if="current.estado == 'B'">
                <i class="fas fa-check-circle"
                  style="font-size: 120px; position: absolute; left: 15px; top: 108px; transform: translateY(-50%); opacity: 0.1; filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0.3)); z-index: 0;"></i>
                <h6>Información Importante.</h6>
                <div>
                  <button class="btn btn-md glow-on-hover" @click="actualizarExistencias()" href="#"
                    style="float:right;">
                    <i class="fas fa-sync"></i>
                    &nbsp;Actualizar Todo
                  </button>
                </div>
                <p>
                  La conversión fue finalizada exitosamente, pero es necesario actualizar las existencias
                  para un funcionamiento óptimo.
                  <br>
                  Hacer caso omiso si la acción ya fue ejecutada.
                </p>
              </div>
              <div class="element-box" style="padding-top: 20px;">
                <div class="btn-group" style="float: right;">
                  <button aria-expanded="false" aria-haspopup="true" class="btn btn-dark dropdown-toggle"
                    data-toggle="dropdown" type="button">
                    <i class="fa fa-cogs"></i>
                    Acciones
                  </button>
                  <div class="dropdown-menu dropdown-menu-right">
                    <button class="dropdown-item" :class="{ disabled: !(current.estado == 'B') }" @click="abrir"
                      :disabled="!(current.estado == 'B')" href="#">
                      <i class="fa fa-unlock"></i>
                      Abrir Operación
                    </button>
                    <button class="dropdown-item" @click="cerrar" :disabled="!(current.estado == 'A')" href="#">
                      <i class="fa fa-lock"></i>
                      Cerrar Operación
                    </button>
                    <div class="dropdown-divider"></div>
                    <button class="dropdown-item" @click="showModalTiendaDuplicar" :disabled="current.estado != 'B'"
                      href="#">
                      <i class="fas fa-copy"></i>
                      Duplicar La Conversión
                    </button>
                    <div class="dropdown-divider"></div>
                    <button class="dropdown-item" @click="generarSalidaPosAntiguo" :disabled=true href="#">
                      <i class="fas fa-upload"></i>
                      Generar salida en POS antiguo
                    </button>
                    <button class="dropdown-item" @click="anular" :disabled="!(current.estado != '9')" href="#">
                      <i class="fa fa-trash"></i>
                      Anular Operación
                    </button>
                  </div>
                </div>
                <br><br>
                <h5 class="form-header" style="text-align: center;">
                  Conversión #{{ current.numero }}
                  <br>
                  <div class="badge" :class="{
                    'badge-success': current.estado == 'A',
                    'badge-warning': current.estado == 'B',
                    'badge-danger': current.estado == '9',
                  }">
                    <i class="fas fa-bullseye"></i>&nbsp;
                    <span v-if="current.estado_str">{{
                      current.estado_str
                      }}</span>
                    <span v-if="!current.estado_str">En Proceso</span>
                  </div>
                </h5>
                <!-- Modal para ver loading bar-->
                <div class="modal fade" id="updateModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
                  aria-hidden="true">
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel" style="float: center;">Actualizando
                          Existencias...
                        </h5>
                      </div>
                      <div class="modal-body">
                        <div class="os-progress-bar primary">
                          <div class="bar-labels">
                            <div class="bar-label-left">
                              <span>Completado:</span>
                            </div>
                            <div class="bar-label-right col-10">
                              <div class="progress">
                                <div class="progress-bar progress-bar-striped bg-success progress-bar-animated"
                                  role="progressbar" :style="{ width: progress + '%' }">
                                  <a style="color: black">{{ progress }}%</a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="st-meta float-right">
                  <div class="element-actions">
                    <!-- <button
                        :disabled="current.estado == 'A'"
                        class="btn btn-outline-dark"
                        @click="imprimir"
                      >
                        <i class="fa fa-print"></i>
                        Imprimir
                      </button> -->
                    &nbsp;
                  </div>
                </div>
                <small v-if="current.errors && current.errors.detail" class="form-text text-danger">{{
                  current.errors.detail }}</small>
                <div class="row">
                  <div class="col-sm-3">
                    <div class="form-group">
                      <label>Código</label>
                      <input v-model="current.producto.sku" autofocus="autofocus" class="form-control"
                        placeholder="Código Producto" type="text" :disabled="true" />
                      <small v-if="current.errors && current.errors.motivo_ajuste" class="form-text text-danger">{{
                        current.errors.motivo_ajuste[0] }}</small>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Nombre</label>
                      <input :disabled="true" class="form-control" v-model="current.producto.nombre" type="text" />
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group">
                      <label>Cantidad</label>
                      <input :disabled="true" class="form-control" v-model="current.cantidad" type="text" />
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group">
                      <TiendaSelectComponent :current="current" :disabled="true" />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Usuario</label>
                      <input :disabled="true" class="form-control" v-model="current.usuario" type="text" />
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group">
                      <label v-bind:class="{
                        'text-danger': current.errors && current.errors.fecha,
                      }">Fecha</label>
                      <input v-model="current.fecha" class="form-control" placeholder="Fecha" :disabled="true"
                        type="text" />
                      <small v-if="current.errors && current.errors.fecha" class="form-text text-danger">{{
                        current.errors.fecha[0] }}</small>
                    </div>
                  </div>
                </div>
                <div class="table-responsive" v-if="current.id != null">
                  <table class="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>SKU</th>
                        <th>Producto</th>
                        <th>Lote</th>
                        <th>Posición</th>
                        <th class="text-center" style="width: 100px">Unidades</th>
                        <th class="text-center" v-if="current.estado == 'A'">Opciones</th>
                        <th class="text-center" v-if="current.estado == 'B'"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="detalle in current.conversiond_set" v-bind:key="detalle.id">
                        <td>{{ detalle.producto.sku }}</td>
                        <td>{{ detalle.producto.nombre }}</td>
                        <td>
                          {{ detalle.producto_lote.codigo_lote }}
                        </td>
                        <td>
                          {{ detalle.tienda_posicion.posicion }}
                        </td>
                        <td class="text-right bolder nowrap" style="font-weight: 500">
                          <span v-if="current.estado == 'B'">
                            {{ detalle.cantidad }}</span>
                          <div class="input-group input-group-sm" v-if="current.estado == 'A'">
                            <div class="input-group-prepend"></div>
                            <input v-on:keyup.enter="modificarDetalle(detalle)" v-if="current.estado == 'A'"
                              class="form-control text-right" v-model="detalle.cantidad" placeholder="cantidad"
                              type="text" />
                            <div class="input-group-append"></div>
                          </div>
                        </td>
                        <td class="text-center" style="width: 100px" v-if="current.estado == 'A'">
                          <button class="btn btn-sm btn-success" type="button" @click="modificarDetalle(detalle)">
                            <i class="far fa-save"></i>
                          </button>
                          <button class="btn btn-sm btn-danger" type="button" @click="eliminarDetalle(detalle)">
                            <i class="fas fa-trash-alt"></i>
                          </button>
                        </td>
                        <td class="text-center" style="width: 100px" v-if="current.estado == 'B'">
                          <button class="btn btn-sm btn-dark" type="button"
                            @click="actualizarExistencia(detalle.producto.sku)">
                            <i class="fas fa-sync"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <br>
                  <!-------------------- END - Basic Table -------------------->
                </div>
                <div class="element-wrapper" v-if="current.estado == 'A'">
                  <div class="element-box">
                    <div class="form-buttons-w" style="float: right;">
                      <button class="btn btn-md btn-primary" v-if="current.estado == 'A'" @click="guardar(current)">
                        Guardar Cambios&nbsp;<i class="fas fa-check"></i>
                      </button>
                      <button type="button" class="btn btn-md btn-info" @click="showModalAddDetail"
                        v-if="current.estado == 'A'">
                        Agregar Producto&nbsp;<i class="fa fa-plus"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div aria-hidden="true" class="modal fade" id="modalAddDetailReqTraslado" role="dialog" tabindex="-1">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Agregar Producto</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row">
                <div class="col-sm-12 mb-1">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        currentDetalle.errors &&
                        currentDetalle.errors.producto,
                    }">Producto</label>
                    <v-select label="nombre" v-model="currentDetalle.producto" :filterable="false" :options="productos"
                      @search="onSearchProducto" @input="setSelected">
                      <template slot="no-options">Producto...</template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          <img :src="option.image" />
                          {{ option.sku }} - {{ option.nombre }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          <img :src="option.image" />
                          {{ option.sku }} - {{ option.nombre }}
                        </div>
                      </template>
                    </v-select>
                    <small v-if="
                      currentDetalle.errors && currentDetalle.errors.producto
                    " class="form-text text-danger">{{ currentDetalle.errors.producto[0] }}</small>
                  </div>
                </div>
                <div v-if="
                  currentDetalle.productolote_set != null &&
                  currentDetalle.productolote_set.length > 0
                " class="col-sm-12 mb-1">
                  Lotes:
                  <select v-model="currentDetalle.codigo_lote" class="form-control" autofocus="autofocus">
                    <option v-for="detalle in currentDetalle.productolote_set" :value="detalle.id"
                      v-bind:key="detalle.id">
                      Lote: {{ detalle.codigo_lote }}
                    </option>
                  </select>
                </div>
                <div class="col-12">
                  Posicion:
                  <select v-model="currentDetalle.posicion" class="form-control">
                    <option v-for="detalle in posiciones" :value="detalle.posicion_id" v-bind:key="detalle.id">
                      {{ detalle.codigo_barra }}
                    </option>
                  </select>
                  <small v-if="
                    currentDetalle.errors && currentDetalle.errors.posicion
                  " class="form-text text-danger">{{ currentDetalle.errors.posicion }}</small>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        currentDetalle.errors &&
                        currentDetalle.errors.cantidad,
                    }">Cantidad en Unidades</label>
                    <input v-on:keyup.enter="agregaDetalle" v-model="currentDetalle.cantidad" class="form-control"
                      placeholder="Cantidad" type="text" style="text-align: center; font-size: 200%" v-bind:class="{
                        'is-invalid':
                          currentDetalle.errors.cantidad &&
                          currentDetalle.errors.cantidad.length > 0,
                      }" />
                    <small v-if="
                      currentDetalle.errors && currentDetalle.errors.cantidad
                    " class="form-text text-danger">{{ currentDetalle.errors.cantidad }}</small>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="agregaDetalle" type="button">
              Añadir&nbsp;<i class="fas fa-check"></i>
            </button>
            <button class="btn btn-danger" ref="cerrarModal" data-dismiss="modal" type="button" @click="cancelAdd()">
              Cancelar&nbsp;<i class="fas fa-times"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div aria-hidden="true" class="modal fade" id="modalAddTiendaDuplicar" role="dialog" tabindex="-1">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Elegir Tienda</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <TiendaSelectComponent :current="duplicar" />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="duplicarConversion(duplicar)" type="button">
              Generar Duplicación
            </button>
            <button class="btn btn-secondary" ref="cerrarModal" data-dismiss="modal" type="button">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import CommonService from "@/services/commons/CommonService";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import ProductosService from "@/services/catalogos/ProductosService";
import PosicionesService from "@/services/inventario/PosicionesService";
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";

export default {
  components: {
    TiendaSelectComponent,
  },
  data() {
    return {
      progress: 0,
      current: {
        id: null,
        estado_str: null,
        tienda: "",
        fecha: "01/01/2019",
        estado: "A",
        motivo_ajuste: "",
        errors: [],
        producto: {},
      },
      duplicar: {},
      productos: [],
      posiciones: [],
      options: [],
      producto_lote: [],

      bodegas: [],
      secciones: [],
      racks: [],
      niveles: [],

      busqueda_posicion: {
        bodega_id: null,
        seccion_id: null,
        rack_id: null,
        posicion_id: null,
      },
      currentDetalle: {
        cantidad: 0,
        posicion: "",
        producto: "",
        codigo_lote: 0,
        productolote_set: [],
        errors: [],
      },
    };
  },
  computed: {
  },
  mounted() {
    let self = this;
    if (this.$route.params.id) {
      self.refreshCurrent(this.$route.params.id);
    }
    self.refreshPosiciones();
  },
  methods: {
    setSelected(value) {
      let self = this;
      ProductosService.getById(value.sku).then((res) => {
        self.currentDetalle.productolote_set = res.data.productolote_set;
        self.currentDetalle.codigo_lote = res.data.productolote_set[0].id;
      });
    },
    generarSalidaPosAntiguo() {
      let self = this;
      Notifications.alert.confirm(
        "¡IMPORTANTE!",
        "Esta acción solo se debe de realizar una vez por cada conversión",
        "",
        function () {
          DynamicService.postAction(
            "inv",
            "conversion-e",
            self.current.id,
            "generar_ajuste_inv"
          ).then((response) => {
            Notifications.alert.success(
              "Salida de Inventario en POS antiguo",
              "Generado Satifactoriamente"
            );
          });
        }
      );
    },
    showModalTiendaDuplicar() {
      $("#modalAddTiendaDuplicar").modal();
    },
    duplicarConversion(duplicar) {
      let self = this;
      if (!duplicar.tienda) {
        Notifications.alert.info("¡Atencion!", "La tienda no puede ir nula");
        return;
      }
      self.tienda = duplicar.tienda;
      Notifications.alert.confirm(
        "Nota",
        "Si realiza esta acción se duplicara toda la información de la conversión ¿Esta de acuerdo?",
        "",
        function () {
          DynamicService.postAction(
            "inv",
            "conversion-e",
            self.current.id,
            "duplicar",
            { tienda: duplicar.tienda }
          )
            .then((response) => {
              Notifications.alert.success(
                "Duplicar Conversión",
                "Realizado con éxito"
              );
              self.id = response.data.conversion_e;
              self.$router.push({
                name: "inventario-conversiones-editar",
                params: { id: self.id },
              });
              $("#modalAddTiendaDuplicar").modal("hide");
              self.refreshCurrent();
              self.refreshDetalleDefault();
            })
            .catch((error) => {
              Notifications.alert.error("Duplicar", error.response.data.detail);
            });
        }
      );
    },
    refreshCurrent() {
      let self = this;
      DynamicService.getById("inv", "conversion-e", this.$route.params.id).then(
        (response) => {
          self.current = response.data;
          self.current.tienda = response.data.tienda.codigo;
          self.current.usuario = response.data.usuario.name;
        }
      );
    },
    refreshPosiciones() {
      let self = this;
      let params = {
        page: 1,
        tienda: self.current.tienda,
        quitar_paginacion: true,
      };
      PosicionesService.fetch(params).then((res) => {
        self.posiciones = res.data;
      });
    },
    guardar(current) {
      let self = this;
      if (current.producto) {
        current.producto = current.producto.sku;
      }
      DynamicService.save("inv", "conversion-e", current).then((response) => {
        Notifications.alert.success(
          "Conversión",
          "Se ha guardado la información"
        );
        self.refreshCurrent();
      });
    },

    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    onSearchProducto(search, loading) {
      loading(true);
      this.searchProducto(loading, search, this);
    },
    searchProducto: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      ProductosService.fetch({
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      }).then((res) => {
        vm.productos = res.data;
        loading(false);
      });
    }, 350),
    showModalAddDetail() {
      let self = this;
      ProductosService.fetch({
        page: 1,
        activo: true,
        permitir_compra: true,
      }).then((res) => {
        self.productos = res.data.results;
      });
      PosicionesService.fetch({
        page: 1,
        tienda: self.current.tienda,
        activo: true,
      }).then((res) => {
        self.posiciones = res.data.results;
      });
      $("#modalAddDetailReqTraslado").modal();
    },
    agregaDetalle() {
      let self = this;
      let det = Object.assign({}, self.currentDetalle);
      if (det.producto) {
        det.producto = det.producto.sku;
      }
      if (det.codigo_lote) {
        det.producto_lote = det.codigo_lote;
      }
      DynamicService.postAction(
        "inv",
        "conversion-e",
        self.current.id,
        "agregar_detalle",
        det
      )
        .then((response) => {
          Notifications.alert.success(
            "Producto Equivalente",
            "Se ha guardado la Información."
          );
          $("#modalAddDetailReqTraslado").modal("hide");
          self.busqueda_posicion = "";
          self.refreshCurrent();
          self.refreshDetalleDefault();
          self.$refs.cerrarModal.click();
        })
        .catch((error) => {
          self.currentDetalle.errors = error.response.data;
        });
    },
    eliminarDetalle(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "Producto Equivalente",
        "¿Esta seguro de eliminar el registro?",
        "Si Eliminar",
        function () {
          DynamicService.postAction(
            "inv",
            "conversion-e",
            self.current.id,
            "eliminar_detalle",
            {
              id: detalle.id,
            }
          )
            .then((response) => {
              Notifications.alert.success(
                "Producto Equivalente",
                "Se ha eliminado la Información."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              self.current.errors = error.response.data;
            });
        }
      );
    },
    modificarDetalle(detalle) {
      let self = this;
      DynamicService.postAction(
        "inv",
        "conversion-e",
        self.current.id,
        "modificar_detalle",
        detalle
      )
        .then((response) => {
          Notifications.alert.success("Información", "Guardado Correctamente");
          self.refreshCurrent();
        })
        .catch((error) => {
          self.current.errors = error.response.data;
        });
    },
    abrir() {
      let self = this;
      Notifications.alert.confirm(
        "Conversión de Producto",
        "Desea Abrir la transacción?",
        "Si Abrir",
        function () {
          DynamicService.postAction(
            "inv",
            "conversion-e",
            self.current.id,
            "abrir"
          )
            .then((response) => {
              Notifications.alert.success(
                "Conversión de Producto",
                "Transaccion abierta puede continuar editando."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Abrir Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    actualizarExistencias() {
      let self = this;
      self.progress = 0;

      Notifications.alert.confirm(
        "Actualizar Existencias",
        "¿Desea actualizar existencias? esta acción puede durar algunos minutos",
        "OK",
        function () {

          $("#updateModal").modal({
            backdrop: 'static',
            keyboard: false
          });

          DynamicService.postAction(
            "inv",
            "conversion-e",
            self.current.id,
            "actualizar_existencias"
          )
            .then((response) => {
              let interval = setInterval(() => {
                if (self.progress < 100) {
                  self.progress += 100;
                } else {
                  clearInterval(interval);
                  $("#updateModal").modal("hide");
                  Notifications.alert.success(
                    "Existencias Actualizadas",
                    "Se completó la actualización."
                  );
                  self.refreshCurrent();
                }
              }, 1000);
            })
            .catch((error) => {
              Notifications.alert.error(
                "Error al actualizar existencias",
                error.response.data.detail || "Hubo un problema al procesar la actualización."
              );
              $("#updateModal").modal("hide");
            });
        }
      );
    },
    cerrar() {
      let self = this;
      Notifications.alert.confirm(
        "Conversión de Producto",
        "Desea cerrar la transacción?",
        "Si Abrir",
        function () {
          DynamicService.postAction(
            "inv",
            "conversion-e",
            self.current.id,
            "cerrar"
          )
            .then((response) => {
              Notifications.alert.success(
                "Conversión de Producto",
                "Se ha cerrado la transacción."
              );
              self.refreshCurrent();
              self.actualizarExistencias();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Cerrar Transacción",
                error.response.data.detail
              );
            });
        }
      );
    },
    anular() {
      let self = this;
      Notifications.alert.confirm(
        "Conversión de Producto",
        "Desea Anular la transacción?",
        "Si Anular",
        function () {
          DynamicService.postAction(
            "inv",
            "conversion-e",
            self.current.id,
            "anular"
          )
            .then((response) => {
              Notifications.alert.success(
                "Conversión de Producto",
                "Se ha anulado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Anular Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    refreshDetalleDefault() {
      let self = this;
      self.duplicar = {};
      self.currentDetalle = {
        cantidad: 0,
        cantidad_um: 0,
        unidad_medida: null,
        producto: {
          sku: null,
          unidad_medida: null,
          errors: [],
        },
        errors: [],
      };
    },
    cancelAdd() {
      let self = this;
      self.refreshDetalleDefault();
      $("#modalAddDetailReqTraslado").modal("hide");
    },
    actualizarExistencia(producto) {
      let self = this;
      self.current.producto = producto;
      DynamicService.postActionList(
        "cat",
        "productos",
        "actualizar_existencias_negativas_x_tienda_producto",
        self.current
      )
        .then((response) => {
          Notifications.toast.success("", "Existencia de producto actualizada correctamente ✔");
          self.refreshCurrent();
        })
        .catch((error) => {
          console.log(error.response.data);
        });
    },
    // imprimir() {
    //   let self = this;
    //   AjusteInventarioService.pdf(self.current.id)
    //     .then((response) => {
    //       console.log(response.data.output);
    //       window.open(response.data.output);
    //     })
    //     .catch((error) => {
    //       Notifications.alert.error(
    //         "No se ha podido realizar la acción",
    //         error.response.data.detail
    //       );
    //     });
    // },
  },
};
</script>
